import { Reducer } from 'redux';

import {
    EmbeddedApiState,
    initialEmbeddedApiState,
    ReceivedMessageState,
    SentMessageState,
} from 'embedded/api/store/EmbeddedApiState';
import {
    EmbeddedApiAction,
    EmbeddedApiActionType,
} from 'embedded/api/store/actions';
import { addItemToArrayWithMaxSize } from 'utils/arrays/arrayUtils';

export const embeddedApiReducer: Reducer<
    EmbeddedApiState,
    EmbeddedApiAction
> = (state = initialEmbeddedApiState, action) => {
    switch (action.type) {
        case EmbeddedApiActionType.EMBEDDED_API_RECEIVE_MESSAGE: {
            const topic = action.payload!.topic;

            const prevTopicMessages: ReceivedMessageState<unknown>[] =
                state.receivedMessages[topic] ?? [];

            const nextTopicMessages = addItemToArrayWithMaxSize(
                { ...action.payload!, seq: state.nextSeq },
                prevTopicMessages,
                100,
                (i) => i.status === 'Received' || i.status === 'Processing'
            );

            const nextReceivedMessages = {
                ...state.receivedMessages,
                [topic]: nextTopicMessages,
            };

            return {
                ...state,
                receivedMessages: nextReceivedMessages,
                nextSeq: state.nextSeq + 1,
            };
        }
        case EmbeddedApiActionType.EMBEDDED_API_UPDATE_RECEIVED_MESSAGE: {
            const uid = action.payload!.uid;
            const prev = find(state, uid);
            if (!prev) {
                return state;
            }
            const next = { ...prev, ...action.payload };
            const prevTopicMessages: ReceivedMessageState<unknown>[] =
                state.receivedMessages[prev.topic];
            const nextTopicMessages = [
                ...prevTopicMessages.filter((u) => u.uid !== uid),
                next,
            ];

            const nextReceivedMessages = {
                ...state.receivedMessages,
                [prev.topic]: nextTopicMessages,
            };

            return { ...state, receivedMessages: nextReceivedMessages };
        }
        case EmbeddedApiActionType.EMBEDDED_API_SEND_MESSAGE: {
            const topic = action.payload!.topic;

            const prevTopicMessages: SentMessageState<unknown>[] =
                state.sentMessages[topic] ?? [];

            const nextTopicMessages = addItemToArrayWithMaxSize(
                { ...action.payload!, seq: state.nextSeq },
                prevTopicMessages,
                100
            );

            const nextSentMessages = {
                ...state.sentMessages,
                [topic]: nextTopicMessages,
            };

            return {
                ...state,
                sentMessages: nextSentMessages,
                nextSeq: state.nextSeq + 1,
            };
        }
        default:
            return state;
    }
};

function find(
    state: EmbeddedApiState,
    uid: string
): ReceivedMessageState<unknown> | undefined {
    for (const topic of Object.keys(state.receivedMessages)) {
        const prev = state.receivedMessages[topic].find((u) => u.uid === uid);
        if (prev) {
            return prev;
        }
    }
}
